// v3/app/App.tsx — V3 entry point
// Imports tokens.css, wraps routes with AppProviders.
// Restores session synchronously before first render.
// Zero imports from v1/v2.

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import '../../v3/design-system/tokens.css';
import { AppProviders } from './providers/AppProviders';
import { V3Routes } from './router/routes';
import { useAuthStore } from '../shared/stores/auth-store';

// Restore session synchronously before React renders anything.
// This ensures ProtectedRoute sees the correct isAuthenticated state on first render.
useAuthStore.getState().restoreSession();

export function V3App() {
  return (
    <BrowserRouter basename="/v3">
      <AppProviders>
        <V3Routes />
      </AppProviders>
    </BrowserRouter>
  );
}
